import styled, { css } from 'styled-components';

const FlipCardStyled = styled.div.attrs({
  className: 'flip-card',
})`
  ${({ flipped }) => {

    return css`
      position: relative;
      perspective: 1000px;

      .flip-card__body {
        display: flex;
        height: 100%;
        max-width: 260px;
        transition: transform .8s;
        transform-style: preserve-3d;
        ${flipped && `transform: rotateY( -180deg );`}
      }

    `;
  }}
`;

export default FlipCardStyled;
